{
    "translation": {
        "test": "texto prueba en"
    }
}
